<div class="archive-partners">
  <p class="desc" [innerHTML]=" 'partner_desc' | content_translate: 'content'"></p>
  <sng-partners-list-scroll></sng-partners-list-scroll>
</div>
